import { render, staticRenderFns } from "./AvatarButton.vue?vue&type=template&id=cc792052"
import script from "./AvatarButton.vue?vue&type=script&lang=js"
export * from "./AvatarButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports